import React, {useCallback, useEffect, useState, useMemo} from 'react';
import {
	Slider,
	Input,
	Button,
	Toast
} from '@kaleyra/emmy';
import Styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import {isEmpty} from "lodash";
import StandardTitle from "../../../../components/StandardTitle";
import {validateIpAddress, validateTitle} from "../../../../utils";
import AddIcon from '../../../../assets/addPlus.svg';
import AddPlusInactiveIcon from '../../../../assets/addPlusInactive.svg';

export type MapStateToPropsType = {
	params: any;
};

export type MapDispatchToPropsType = {
	closeModal: () => void,
	addSipAcl : (reqData: any, cb?: (res: any, success: boolean) => void) => void,
	addSipIpAddresses : (reqData: any, filters:any, dynamicUrlData:string, cb?: (res: any, success: boolean) => void) => void,
	removeSipIpAddressInstance : () => void
	removeAclInstance : () => void
};

const FilterModal: React.FC<MapStateToPropsType & MapDispatchToPropsType> = (
	{
		closeModal,
		params,
		addSipAcl,
		addSipIpAddresses,
		removeSipIpAddressInstance,
		removeAclInstance,
	}) => {
	const [title, setTitle] = useState<undefined|string>(undefined);
	const [ipAddresses, setIpAddresses] = useState<string[]>([""]);
	const [invalidIpAddresses, setInvalidIpAddresses] = useState<number[]>([]);
	const { t } = useTranslation();
	const { aclData, onlyAddIpAddresses = false } = params;

	useEffect(()=>{
		if(!isEmpty(aclData)){
			setTitle(aclData.ip_acl_name);
		}
		return () => {
			if(!onlyAddIpAddresses) removeSipIpAddressInstance();
			else removeAclInstance();
		}
	},[])
	const handleSave = useCallback(() => {
		if(!title || !ipAddresses) return;
		if(!onlyAddIpAddresses){
			addSipAcl({
					ip_acl_name:title,
					ip_addrs:ipAddresses,
			}
			,(res,success)=>{
				if(success) Toast(t('KLR00709'),'success');
			});
		}else{
			addSipIpAddresses({},
				{},
				"",
				(res,success) => {
					if (success) Toast(t('KLR00488'), 'success');// todo change success message
				}
			);
		}
		closeModal();
	},[title]);

	const enableSaveButton = useMemo(() => {
		if(!title || isEmpty(ipAddresses)) return false;
		if(!validateTitle(title)) return false;
		return ipAddresses.every(el => !!el && validateIpAddress(el));
	},[title,ipAddresses]);

	const renderFooter = () => {
		return (
			<div className={Styles.footer}>
				<span className={Styles.cancelBtn}>
					<Button type="tertiary" onClick={closeModal}>
						{t('mainCancel')}
					</Button>
				</span>
				<Button
					disabled={!enableSaveButton}
					type="primary"
					onClick={handleSave}
				>
					{t('mainSave')}
				</Button>
			</div>
		);
	};
	const handleChangeIpAddresses = useCallback((val:string,index:number)=>{
		setIpAddresses((preIpAddresses:string[])=>{
			const newArr = [...preIpAddresses];
			if(newArr.length>index) newArr[index] = val;
			return newArr;
		});
	},[]);
	const enableAddIp = useMemo(()=>{
		return ipAddresses.every(el => validateIpAddress(el));
	},[ipAddresses]);

	const addNewIp = useCallback(() => {
		setIpAddresses((prevState => {
			if(prevState.length >= 10) return prevState;
			if(!prevState[prevState.length-1]) return prevState;
			return [
				...prevState,
				""
			];
		}))
	},[]);
	return (
		<Slider
			title={t('KLR00702')}
			containerId="root-modal"
			onClose={closeModal}
			visibility={true}
			footer={renderFooter()}
		>
			<div className={cn(Styles.container, 'addSipAclModal')}>
				<StandardTitle
					label="mainTitle"
					placeholder="mainTitle"
					title={title}
					setTitle={setTitle}
					disable={onlyAddIpAddresses}
				/>
				<div className={Styles.compSubHeader}>
					{t('KLR00701')}
				</div>
				{ipAddresses && ipAddresses.map( (address:string, index:number) => (
					<Input
						placeholder={t('KLR00704')}
						inputClassName={Styles.ipBox}
						className={cn(Styles.mrgBtm)}
						label={t('KLR00704')}
						value={address}
						showBottomLabelSpace={ false }
						key={`${index}`}
						bottomLabelType={ invalidIpAddresses.includes(index) ? "error" : undefined}
						bottomLabel={
							invalidIpAddresses.includes(index) ? t("Invalid ip address") : false
						}
						onChange={(e: any) => {
							handleChangeIpAddresses(e.target.value,index);
							const isIncluded = invalidIpAddresses.includes(index);
							if(isIncluded) setInvalidIpAddresses( prevState => {
								return prevState.filter(el => el !== index);
							})
						}}
						onBlur={(e: any) => {
							const val = (e.target.value).trim();
							const isValid = validateIpAddress(val);
							const isIncluded = invalidIpAddresses.includes(index);
							if(!isValid && !isIncluded) setInvalidIpAddresses(prevState => {
								return [
									...prevState,
									index
								]
							});
							if(isValid && isIncluded) setInvalidIpAddresses( prevState => {
								return prevState.filter(el => el !== index);
							})
						}}
					/>))
				}
				<div onClick={addNewIp} className={cn(Styles.addNewIp, !enableAddIp ? Styles.disabled : "")}>
					<img src={enableAddIp ? AddIcon : AddPlusInactiveIcon} alt={'Add icon'}/>
					<span className={Styles.addIpBtn}>
						{t('KLR00705')}
					</span>
				</div>
			</div>
		</Slider>
	);
};

export default FilterModal;
